import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { ControlIcons } from 'owa-control-icons';
import ChatHeaderGroupMemberList from './ChatHeaderGroupMemberList';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

export interface ChatHeaderGroupInfoButtonProps {
    participants: string[];
}

const styles = require('./ChatHeaderGroupInfoButton.scss');

export default function ChatHeaderGroupInfoButton(props: ChatHeaderGroupInfoButtonProps) {
    const [isCalloutVisible, setIsCalloutVisible] = React.useState(false);
    const [buttonTarget, setButtonTarget] = React.useState(null);

    const onNewRef = React.useCallback((newRef: IconButton) => {
        setButtonTarget(ReactDOM.findDOMNode(newRef));
    }, []);

    const onButtonClicked = React.useCallback(
        (e: React.MouseEvent<unknown>) => {
            e.preventDefault();
            e.stopPropagation();
            setIsCalloutVisible(!isCalloutVisible);
        },
        [isCalloutVisible]
    );

    const onDismissCallout = React.useCallback(() => {
        setIsCalloutVisible(false);
    }, []);

    const { participants } = props;
    return (
        <>
            <IconButton
                ref={onNewRef}
                iconProps={{
                    iconName: ControlIcons.People,
                    styles: {
                        root: styles.iconMargin,
                    },
                }}
                onClick={onButtonClicked}
                styles={{
                    root: styles.groupButton,
                    flexContainer: styles.flexContainer,
                }}>
                {participants.length}
            </IconButton>
            {buttonTarget && isCalloutVisible && (
                <Callout
                    className={styles.groupMemberListCallout}
                    target={buttonTarget}
                    isBeakVisible={false}
                    directionalHint={DirectionalHint.bottomCenter}
                    onDismiss={onDismissCallout}>
                    <ChatHeaderGroupMemberList participants={participants} />
                </Callout>
            )}
        </>
    );
}
